import { Avatar as e } from "../Avatar/Avatar.mjs";
import { Image as t } from "../Image/Image.mjs";
import { Icons as n } from "../Icons/Icons.mjs";
import { IconButton as r } from "../Button/IconButton.mjs";
import { ActionCardTone as i } from "./types/ActionCardTone.mjs";
import { Body as a, Card as o, Chevron as s, DismissSlot as c, Figure as l, FigureCaption as u, FigureGroup as d, Kicker as f, Media as p, Meta as m, Title as h, TitleRow as g, TopRow as _, UrgencyPill as v } from "./styled/ActionCard.styled.mjs";
import "react";
import { jsx as y, jsxs as b } from "react/jsx-runtime";
//#region src/components/ActionCard/ActionCard.tsx
var x = " · ", S = ({ tone: S = i.Decision, kicker: C, urgency: w, urgent: T = !1, title: E, subtitle: D, facets: O, figure: k, figureCaption: A, imageUrl: j, avatarName: M, icon: N, onClick: P, onDismiss: F, dismissLabel: I, className: L }) => {
	let R = !!P, z = [D, ...O ?? []].filter(Boolean).join(x);
	return /* @__PURE__ */ b(o, {
		$tone: S,
		$interactive: R,
		className: L,
		onClick: P,
		role: R ? "button" : void 0,
		tabIndex: R ? 0 : void 0,
		onKeyDown: R ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), P?.());
		} : void 0,
		children: [
			/* @__PURE__ */ y(p, { children: j ? /* @__PURE__ */ y(t, {
				src: j,
				alt: "",
				width: "100%",
				height: "100%",
				fit: "cover"
			}) : M ? /* @__PURE__ */ y(e, {
				size: "md",
				fallback: M
			}) : N ?? /* @__PURE__ */ y(n.AlertCircle, {}) }),
			/* @__PURE__ */ b(a, { children: [
				/* @__PURE__ */ b(_, { children: [/* @__PURE__ */ y(f, { children: C }), w ? /* @__PURE__ */ b(v, {
					$urgent: T,
					children: [/* @__PURE__ */ y(n.Clock, {}), w]
				}) : null] }),
				/* @__PURE__ */ b(g, { children: [/* @__PURE__ */ y(h, { children: E }), k ? /* @__PURE__ */ b(d, { children: [/* @__PURE__ */ y(l, { children: k }), A ? /* @__PURE__ */ y(u, { children: A }) : null] }) : null] }),
				z ? /* @__PURE__ */ y(m, { children: z }) : null
			] }),
			R ? /* @__PURE__ */ y(s, { children: /* @__PURE__ */ y(n.ChevronRight, {}) }) : null,
			F ? /* @__PURE__ */ y(c, { children: /* @__PURE__ */ y(r, {
				size: "sm",
				variant: "ghost",
				label: I,
				icon: /* @__PURE__ */ y(n.X, { size: 13 }),
				onClick: (e) => {
					e.stopPropagation(), F();
				},
				onKeyDown: (e) => e.stopPropagation()
			}) }) : null
		]
	});
};
//#endregion
export { S as ActionCard };
